import { Link, Navigate, useParams } from 'react-router-dom';
import { findCourseBySlug } from '@/lib/content';
import { attemptStore } from '@/lib/storage';

export default function Course() {
  const { courseSlug = '' } = useParams();
  const course = findCourseBySlug(courseSlug);

  if (!course) return <Navigate to="/" replace />;

  return (
    <>
      <header className="home-header">
        <div className="badge">{course.code} · FIT</div>
        <h1>{course.title}</h1>
      </header>

      <div className="unit-list">
        {course.exam && (
          <Link to={`/q/${course.exam.id}`} className="unit-card exam-card">
            <div className="uc-num">🎓 Final Exam</div>
            <div className="uc-title">40 questions · 90 minutes · timed</div>
            <div className="uc-meta">
              <span>
                {course.exam.examUnits?.map((s) => `Unit ${s.unitNumber}`).join(', ')} ·{' '}
                {course.exam.questions.length} in pool
              </span>
              {attemptStore.bestScore(course.exam.id) && (
                <span className="uc-best">Best: {attemptStore.bestScore(course.exam.id)!.pct}%</span>
              )}
            </div>
          </Link>
        )}

        {course.units.map((unit) => {
          const best = attemptStore.bestScore(unit.id);
          const empty = unit.questions.length === 0;
          return (
            <Link key={unit.id} to={`/q/${unit.id}`} className="unit-card">
              <div className="uc-num">Unit {unit.unitNumber}</div>
              <div className="uc-title">{unit.unitTitle}</div>
              <div className="uc-meta">
                {empty ? (
                  <span className="uc-empty">Coming soon</span>
                ) : (
                  <span>{unit.questions.length} questions</span>
                )}
                {best && <span className="uc-best">Best: {best.pct}%</span>}
              </div>
            </Link>
          );
        })}
      </div>

      <div className="course-back">
        <Link to="/" className="back-link">← All courses</Link>
      </div>
    </>
  );
}
